import axios from 'axios';

export default class AccessManager {

    logout() {
        localStorage.setItem("TMAUser", null);
        window.location = '/';
    }
}